<i18n>
 {
   "cl": {
     "title": "Creditú"
   },
   "pe": {
     "title": "Creditú"
   },
   "br": {
     "title": "Creditú"
   }
 }
</i18n>
<template>
  <div id="app" :class="country">
    <router-view />
  </div>
</template>

<script>

export default {
  data() {
    return {
      timer: null
    };
  },
  computed: {
    country() {
      return this.$i18n.locale;
    }
  },
  mounted() {
    this.presenceTimer = setInterval(() => {
      this.sendPresence();
    }, 5 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.presenceTimer);
  },
  async beforeMount() {
    const title = document.createElement('title');
    title.innerHTML = this.$t('title');
    document.head.appendChild(title);
    this.addElementToHead('32x32');
    this.addElementToHead('192x192');
    this.addElementToHead('180x180', 'apple-touch-icon-precomposed');
    this.addElementToHead('270x270', undefined, 'meta');
  },
  methods: {
    sendPresence() {
      try {
        if (!(this.$store.state.currentUser && this.$store.state.currentUser.user)) {
          return;
        }
        if (!document.hasFocus()) {
          return;
        }
        const presence = {
          country: this.country,
          view: this.$route.name,
          user_id: this.$store.state.currentUser.user._id,
          user_rol: this.$store.state.currentUser.user.rol
        };
        if (this.$store.state.currentUser.user.rol === 'INVESTOR' && this.$store.state.currentUser.user.investorsIds) {
          presence.metadata = { investorsIds: this.$store.state.currentUser.user.investorsIds };
        }
        // this.$socket.emit('presence', presence);
      } catch (error) {
        this.$log.error('Error sending presence', error);
      }
    },
    addElementToHead(sizes, rel = 'icon', type = 'link') {
      const name = {
        cl: 'Favicon_CrediTú',
        pe: 'Favicon_CrediTú',
        br: 'Favicon_CrediTú'
      };
      const element = document.createElement(type);
      const src = require(`@/ui/assets/${this.country}/favicon/cropped-${name[this.country]}-${sizes}.png`); // eslint-disable-line
      if (type === 'link') {
        element.rel = rel;
        element.href = src;
        element.sizes = sizes;
      } else {
        element.name = 'msapplication-TileImage';
        element.content = src;
      }
      element.sizes = sizes;
      document.head.appendChild(element);
    }
  }
};
</script>
